import { render, staticRenderFns } from "./PastTasks.vue?vue&type=template&id=a96b0520&scoped=true"
import script from "./PastTasks.vue?vue&type=script&lang=js"
export * from "./PastTasks.vue?vue&type=script&lang=js"
import style0 from "./PastTasks.vue?vue&type=style&index=0&id=a96b0520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96b0520",
  null
  
)

export default component.exports